import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * RequireEmailVerified Guard
 * Redirects users with unverified emails to verification screen
 * Preserves intended destination via 'next' query param
 */
export default function RequireEmailVerified({ children }) {
  const { isEmailVerified } = useAuth();
  const location = useLocation();

  if (!isEmailVerified) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/verify?next=${next}`} replace />;
  }

  return children;
}
